module.exports = __webpack_public_path__ + "static/media/metepec.c135a57c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/centers/metepec.png
// module id = 622
// module chunks = 0